import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { LoginService } from 'src/app/accountancy/authentication/login/login-service/login.service';
import { ApiRoutes } from 'src/app/accountancy/utilities/classes/api-routes.class';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';
import { ApiGetResponse, ApiPutResponse } from 'src/app/accountancy/utilities/interfaces/global.interface';
import { LiquidationInterface, LiquidationStatusUpdate } from 'src/app/accountancy/utilities/interfaces/liquidation.interface';
import { HttpApiService } from 'src/app/accountancy/utilities/services/http-api/http-api.service';

@Injectable({
  providedIn: 'root'
})
export class LiquidationService {


  constructor(

    private _loginS: LoginService,
    private _api: HttpApiService,
  ) { }

  // public addAccountItem(Items: any[]) {
  //   return this._api.sendPostRequest<HttpResponse<any>>(
  //     `/api/v1/disbursement-voucher/item`,
  //     { Items },
  //   ).pipe(map(values => values.body));
  // }

  public addLiquidationItem(liqId: number, body: Object[]) {
    return this._api.sendPostRequest<HttpResponse<any>>(
      `/api/v1/liquidation/${liqId}/items`,
      body,
      this._loginS.getTokenHeader,
    ).pipe(map(data => data.body))
  }

  public approveRequest(liqId: number, remarks: string) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(
      `/api/v1/liquidation/${liqId}/approval`,
      {
        action: "Approved",
        remarks,
      },
      this._loginS.getTokenHeader,
    ).pipe(map(values => values.body));
  }

  public disapproveRequest(liqId: number, remarks: string) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(
      `/api/v1/liquidation/${liqId}/approval`,
      {
        action: "Disapproved",
        remarks,
      },
      this._loginS.getTokenHeader,
    ).pipe(map(values => values.body));
  }

  public getSingleLiquidation(ID: number) {
    return this._api.sendGetRequest<HttpResponse<LiquidationInterface>>(
      `${ApiRoutes.liquidation}/${ID}`,
      this._loginS.getTokenHeader,
    ).pipe(
      map(values => values.body),
    );
  }

  public updateStatus(ID: number, body: Object) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(
      `/api/v1/liquidation/${ID}/status`, body,
      this._loginS.getTokenHeader
    ).pipe(
      map(values => values.body),
    );
  }

  public updateItemStatus(
    ID: number,
    itemId: number,
    body: LiquidationStatusUpdate
  ) {
    return this._api.sendPutRequest(
      `/api/v1/liquidation/${ID}/items/${itemId}/status`,
      body,
      this._loginS.getTokenHeader
    );
  }

  public toCashReturn(liquidationId: number, body: Object) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(`${ApiRoutes.liquidationUpdate}/${liquidationId}/status`, {
      Status: "For Cash Refund",
      CashReturnInfo: body,
    }, this._loginS.getTokenHeader).pipe(map(values => values.body));
  }

  public toLiquidation(liquidationId: number, body: Object) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(`${ApiRoutes.liquidationUpdate}/${liquidationId}/status`, {
      Status: "For Liquidation",
      LiquidationInfo: body,
    }, this._loginS.getTokenHeader).pipe(map(values => values.body));
  }

  public updateLiquidationStatus(liquidationId: number, nextStatus: string, Total_Cost?: number) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(`${ApiRoutes.liquidationUpdate}/${liquidationId}/status`,
      Total_Cost ? {
        Status: nextStatus,
        Total_Cost,
      } : {
        Status: nextStatus,
      },
      this._loginS.getTokenHeader).pipe(map(values => values.body));
  }

  public getForLiquidation(start?: number | null, limit?: number | null, query?: string | null, body?: Object) {
    return this._api.sendGetRequest<HttpResponse<ApiGetResponse<LiquidationInterface>>>(
      // `${ApiRoutes.liquidation}?${start != undefined ? 'Start=' + start : ''}${limit ? '&Limit=' + limit : ''}${query ? '&Search=' + query : ''}${by ? '&RequestedBy=' + by : ''}${approver ? '&Approver=' + approver : ''}`,
      Helper.url.toParams(ApiRoutes.liquidation, {
        Start: start,
        Limit: limit,
        Search: query,
        ...body,
      }),
      this._loginS.getTokenHeader
    );
  }

  public fileLiquidation(liquidationId: number, body: Object) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(`${ApiRoutes.liquidationUpdate}/${liquidationId}`, {
      ...body
    }, this._loginS.getTokenHeader).pipe(map(values => values.body));
  }

  public updateCashReturnStatus(cashReturnId: number, nextStatus: string) {
    return this._api.sendPutRequest<HttpResponse<ApiPutResponse<LiquidationInterface>>>(`${ApiRoutes.cashReturnUpdate}/${cashReturnId}/status`, {
      Status: nextStatus,
    }, this._loginS.getTokenHeader).pipe(map(values => values.body));
  }

  public getForCashReturn(start?: number | null, limit?: number | null, query?: string | null, by?: number | null, approver?: number | null) {
    return this._api.sendGetRequest<HttpResponse<ApiGetResponse<LiquidationInterface>>>(
      `${ApiRoutes.cashReturn}?${start != undefined ? 'Start=' + start : ''}${limit ? '&Limit=' + limit : ''}${query ? '&Search=' + query : ''}${by ? '&RequestedBy=' + by : ''}${approver ? '&Approver=' + approver : ''}`,
      this._loginS.getTokenHeader
    );
  }

}
